/*
http://localhost:8000/sapi/snap_scan/{ trade_record_id }/
Snap Pay 扫码枪支付接口，仅当选择snap pay的微信扫码支付或支付宝扫码支付时，才能调用这个接口。
:param request:
    {
        "auth_code": "32142131231", # 扫码枪所扫描的家长支付宝或微信支付的付款二维码
        "send_email_or_not": 0, # 是否在成功后发邮件，0:不发，1:发。仅在成功后才发
        "email_recipient": “yanan.song@richwaytech.ca” # 收件人email
    }

:param pk: trade_record_id
:return:
    支付成功时：
    {
        'creation_result’: 'success’,
        'payment_result’: 'success’,
        'school_student_id’: trade_record.trStudent_id,
        'school_student_name’: trade_record.trStudent.ssName,
        'trade_id’: pk,
        'trade_type’: trade_record.trType,
        'amount_of_money’: trade_record.trTransactionAmount,
        'payment_state’: trade_record.payment_state,
        'class_id’: trade_record.trClass_id,
    }

    创建成功，但支付是否成功还需要调接口确认时：
    response_data = {
        'creation_result': 'success',
        'payment_result': 'to be queried',
        'school_student_id': trade_record.trStudent_id,
        'school_student_name': trade_record.trStudent.ssName,
        'trade_id': pk,
        'trade_type': trade_record.trType,
        'amount_of_money': trade_record.trTransactionAmount,
        'payment_state': trade_record.payment_state,
        'class_id': trade_record.trClass_id,
    }

    如果支付方式不是微信扫码支付或者支付宝扫码支付，则不应调这个接口，返回错误：
    {'result': 'failure', 'reason': 'wrong source_or_direction.'}

    如果该trade_record已经被支付完成了，或者其他无法支付的状态，则返回错误：
    {'result': 'failure', 'reason': 'this trade_record can not be paid'}

*/

import axios from "axios";
import queryString from 'query-string';
import Joi from 'joi-browser';
import { APIAddress } from "constants/config";

export const schema = Joi.object().keys({
	auth_code: Joi.string().required(),
	email_recipient: Joi.string().allow(''),
  send_email_or_not: Joi.boolean(),
});

export default function snapScan(tradeID, params) {
  let validateResult = Joi.validate(params, schema);

  if (validateResult.error) {
    return new Promise((resolve, reject)=> {
      reject(validateResult);
    });
  }

  params.send_email_or_not = params.send_email_or_not ? 1 : 0;

	return new Promise((resolve, reject) => {
    axios.put(APIAddress, {'uri': `/snap_scan/${tradeID}/`,
		'method': 'POST',
		'data': JSON.stringify(params),
		'token': localStorage.getItem('token') })
		.then((res) => {
			resolve(res.data);
		})
		.catch((err) => {
			reject(err);
		})
	})
}



// WEBPACK FOOTER //
// ./src/controllers/controllers/payment/snapScan.js